import styled from "@emotion/styled";

export const Message = styled.div({
    fontSize: "16px",
});

export const Loading = styled.div({
    height: 120,
    marginTop: 30,
});

export const NoteBody = styled.div({
    width: 600,
});

export const Footer = styled.div({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
});
